import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import './design/kit.css';
import { App } from './app/App';
import { applyTheme, savedTheme } from './lib/ux/preferences';

// ADR-110: the theme this device chose (or the phone's setting) before the first paint.
applyTheme(savedTheme(), false);

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
